import * as React from 'react';

import { 
  FilterArtModel,
  GlobalPrivateState, 
  QueryParemeterPayload, 
  addFilterParam,
  FilterBackwallModel,
  FilterOverflowModel,
  InputModel,
} from '../../../../../api';

import classNames from 'classnames';

import { connect } from 'react-redux';
import { assign as _assign } from 'lodash';
import { remove as _remove } from 'lodash';

import './../TroughFilter.scss';

type FilterFormData = FilterArtModel | FilterBackwallModel | FilterOverflowModel;

export interface TroughFilterOrProps {
  dispatch: any;
  fields: FilterFormData;
  params: QueryParemeterPayload;
  queryKey: 'art' | 'overflow' | 'backwall';
}

export interface TroughFilterOrState {
  formFields?: FilterFormData;
  filter?: QueryParemeterPayload;
}

export class TroughFilterOrPartial extends React.Component<TroughFilterOrProps, TroughFilterOrState> {
  
  constructor(props: TroughFilterOrProps) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.state = {
      formFields: props.fields,
    };
  }
  
  public render() {
    const {
      queryKey
    } = this.props;

    const {
      formFields,
    } = this.state;

    return (
      <>
        {formFields && Object.keys(formFields).map((fieldKey: string, index: number) => {
          const key = `form_field_${fieldKey}_${index}`;
          const field: InputModel & {checked: boolean} = formFields[fieldKey];
          const checked = this.filter && this.filter[queryKey] && this.filter[queryKey] === field.value ? true : false;
          const disabled = this.filter && this.filter[queryKey] && this.filter[queryKey] !== field.value ? true : false;

          return (
            <div key={key} className="filter-btns">
              <div className="position-relative position-relative form-group">
                <label htmlFor={key} className={classNames('font-weight-bold small', {'active': checked, 'disabled': disabled})}>
                  <span className={classNames('field-label', {'active': checked})}>
                    {field.label}
                  </span>
                  <input 
                    className="form-control border-top-0 border-left-0 border-right-0 p-0" 
                    id={key} 
                    name={field.name} 
                    onChange={this.handleChange}
                    type="checkbox" 
                    value={field.value as string}
                    checked={checked}
                  />
                  <span className="checkmark" />
                </label>
              </div>
            </div>
          );
        })}
      </>
    );
  }

  private get filter(): QueryParemeterPayload['filter'] | undefined {
    return this.props.params && this.props.params.filter;
  }

  private handleChange(event: React.SyntheticEvent<HTMLInputElement>) { 
    let filter: QueryParemeterPayload['filter'] | {} = this.filter || {};
    const fields = this.state.formFields;
    const target = event.target as HTMLInputElement;
    const value = target.value;

    if (filter) {
      filter = _assign({}, {[this.props.queryKey]: target.checked ? value : undefined});
    }

    if (fields && this.state.formFields) {
      Object.keys(fields).map((key) => {
        if (key === value) {
          fields[key].checked = this.state.formFields && !this.state.formFields[key].checked;
        } else {
          fields[key].checked = false;
        }
      });
    }

    this.props.dispatch(addFilterParam(filter));

    this.setState({
      formFields: fields
    });
  }
}

export const ThroughFilterFormOr = connect((state: GlobalPrivateState) => ({
  params: state.queryState.params,
}))(TroughFilterOrPartial);

export default ThroughFilterFormOr;